// SUPER ADMIN DASHBOARD > CompaniesListPage > CompaniesListLayer

import { Icon } from "@iconify/react/dist/iconify.js";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import * as XLSX from "xlsx";
import PopupForm from "./popupForm";

const CompaniesListLayer = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 15;
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [userModalShow, setUserModalShow] = useState(false);
  const [licenseModal, setLicenseModal] = useState(false);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [forms, setForms] = useState([]);
  // const [selectedUser, setSelectedUser] = useState({});
  const [days, setDays] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [planCategory, setPlanCategory] = useState("");
  const [isCustom, setIsCustom] = useState(false);
  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const [scanLimit, setScanLimit] = useState("");
  const [isCustomScanLimit, setIsCustomScanLimit] = useState(false);
  const navigate = useNavigate();

  // ✅ Move fetchData outside useEffect
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/admin/`,
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      // Sort data by createdAt descending (newest first)
      const sortedData = data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      setForms(sortedData);
    } catch (error) {
      console.error("Error fetching forms:", error.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const totalPages = Math.ceil(forms.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentUsers = forms.slice(indexOfFirstRecord, indexOfLastRecord);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = (id) => {
    setShowModal(true);
    setSelectedFormId(id);
  };

  const handleGenerateLicense = (id) => {
    setLicenseModal(true);
    setSelectedAdminId(id);
  };

  const handleConfirm = async () => {
    if (!selectedFormId) return;

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/admin/${selectedFormId}`,
      );

      if (response.status === 200) {
        alert(response.data.message);
        setShowModal(false); // ✅ Close the modal on success
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting admin:", error.message);
      alert("Failed to delete admin. Please try again."); // ✅ Show an alert on error
    } finally {
      setShowModal(false); // ✅ Ensure modal closes even on error
    }
  };

  // const handlePreview = async (id, cid) => {
  //   try {
  //     const [adminRes, scanRes] = await Promise.all([
  //       axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/details/${id}`),
  //       axios.get(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/form/getScanCount?companyId=${cid}`
  //       ),
  //     ]);

  //     if (adminRes.status === 200 && scanRes.status === 200) {
  //       setSelectedUser({
  //         ...adminRes.data.admin,
  //         scanCount: scanRes.data.count || 0,
  //       });
  //       setUserModalShow(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching admin or scan count:", error.message);
  //   }
  // };
  const handlePreview = (id, cid) => {
    console.log("Previewing user with ID:", id, "and CID:", cid);
    if (!id) return;
    navigate(`/user-details/${id}/${cid}`); // Pass both id and cid in the URL
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   const token = localStorage.getItem("superAdminToken");

  //   if (!token) {
  //     alert("Super Admin not authenticated.");
  //     return;
  //   }

  //   if (!days || isNaN(days)) {
  //     alert("Please enter valid number of days.");
  //     return;
  //   }

  //   try {
  //     setIsSubmitting(true);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/superAdmin/generate-license`,
  //       {
  //         planCategory: planCategory,
  //         adminId: selectedAdminId,
  //         validityDays: Number(days),
  //         monthlyScanLimit: scanLimit,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       alert("License generated successfully.");

  //       setLicenseModal(false);
  //     } else {
  //       alert("Failed to generate license.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert(error.response?.data?.message || "Server error");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const token = localStorage.getItem("superAdminToken");

    if (!token) {
      alert("Super Admin not authenticated.");
      setIsSubmitting(false);
      return;
    }

    if (!days || isNaN(days)) {
      alert("Please enter a valid number of days.");
      setIsSubmitting(false);
      return;
    }

    try {
      // Build payload conditionally
      const payload = {
        planCategory,
        adminId: selectedAdminId,
        validityDays: Number(days),
      };

      // Only add monthlyScanLimit for basic plan
      if (planCategory === "basic") {
        if (!scanLimit || isNaN(scanLimit)) {
          alert("Please enter a valid scan limit for Basic plan.");
          setIsSubmitting(false);
          return;
        }
        payload.monthlyScanLimit = Number(scanLimit);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/superAdmin/generate-license`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        alert("License generated successfully.");
        setLicenseModal(false);
      } else {
        alert("Failed to generate license.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert(
        error.response?.data?.error ||
          error.response?.data?.message ||
          "Server error",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleExportToExcel = () => {
    // Sample data structure - use your actual array of users
    const exportData = forms.map((user) => {
      const isActive =
        new Date(user.trialEndDate).setHours(23, 59, 59, 999) >= new Date();

      return {
        "Company ID": user.cid,
        Name: user.name,
        Email: user.email,
        Mobile: `+91 ${user.cmobile}`,
        "Start Date": new Date(
          user.plan === "trial" ? user.trialStartDate : user.licenseStartDate,
        ).toLocaleDateString(),
        "End Date": new Date(
          user.plan === "trial" ? user.trialEndDate : user.licenseExpiryDate,
        ).toLocaleDateString(),
        Type: user.plan === "trial" ? "Trial" : "Paid",
        PlanCategory: user.planCategory,
        Status:
          new Date(
            user.plan === "trial" ? user.trialEndDate : user.licenseExpiryDate,
          ).setHours(23, 59, 59, 999) >= new Date()
            ? "Active"
            : "Expired",
      };
    });

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    // Convert workbook to Excel buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save using file-saver
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "companies.xlsx");
  };

  return (
    <div className="card radius-16 mt-24">
      <div className="card-body">
        {/* Button to open popup form*/}
        <div className="d-flex align-items-center flex-wrap gap-4 justify-content-end mb-20">
          <button
            className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-sm btn-sm px-8 py-6"
            onClick={handleExportToExcel}
          >
            <Icon icon="ph:arrow-up" className="icon text-md" />
            Export
          </button>
          <button
            onClick={() => setIsOpen(true)}
            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 text-sm btn-sm px-8 py-6"
          >
            <Icon icon="ph:plus-circle" className="icon text-xl" />
            Add Company
          </button>
        </div>

        {/* Popup Form */}
        {/* {isOpen && <PopupForm onClose={() => setIsOpen(false)} />} */}
        {forms.length === 0 ? (
          <div className="text-center py-5">
            <h4>No records found</h4>
            <p>There are no forms to display at the moment.</p>
          </div>
        ) : (
          <div className="table-responsive scroll-md">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  {/* <th>Logo</th> */}
                  <th className="text-center">Company ID</th>
                  <th className="text-center">Company Name</th>
                  <th className="text-center">Company Email</th>
                  <th className="text-center">Company Mobile No.</th>
                  <th className="text-center">Subscription Start Date</th>
                  <th className="text-center">Subscription End Date</th>
                  <th className="text-center">Plan Type</th>
                  <th className="text-center">Subscription Type</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user, index) => (
                  <tr key={index}>
                    <td className="text-center">{user.cid}</td>
                    {/* <td className="text-center">
                      <Link
                        to={`/user-details/${user._id}`}
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          fontWeight: "bold",
                        }}
                      >
                        {user.name}
                      </Link>
                    </td>{" "} */}
                    <td className="text-center">{user.name}</td>
                    <td className="text-center">{user.email}</td>
                    <td className="text-center">+91 {user.cmobile}</td>
                    <td className="text-center">
                      {user.plan === "trial" && user.trialStartDate
                        ? new Date(user.trialStartDate).toLocaleDateString(
                            "en-GB",
                          )
                        : user.licenseStartDate
                          ? new Date(user.licenseStartDate).toLocaleDateString(
                              "en-GB",
                            )
                          : "-"}
                    </td>

                    <td className="text-center">
                      {user.plan === "trial" && user.trialEndDate
                        ? new Date(user.trialEndDate)
                            .toISOString()
                            .slice(0, 10)
                            .split("-")
                            .reverse()
                            .join("/")
                        : user.licenseExpiryDate
                          ? new Date(user.licenseExpiryDate)
                              .toISOString()
                              .slice(0, 10)
                              .split("-")
                              .reverse()
                              .join("/")
                          : "-"}
                    </td>

                    {/* <td className="text-center">Trial</td> */}
                    <td className="text-center">
                      {user.plan ? user.plan.toUpperCase() : "-"}
                    </td>
                    <td className="text-center">
                      {user.planCategory
                        ? user?.planCategory.toUpperCase()
                        : "N/A"}
                    </td>
                    <td className="text-center">
                      <span
                        className={`${
                          new Date(
                            user.plan === "trial"
                              ? user.trialEndDate || 0
                              : user.licenseExpiryDate || 0,
                          ).setHours(23, 59, 59, 999) >= new Date()
                            ? "bg-success-focus text-success-main"
                            : "bg-danger-focus text-danger-main"
                        } px-24 py-4 rounded-pill fw-medium text-sm`}
                      >
                        {new Date(
                          user.plan === "trial"
                            ? user.trialEndDate || 0
                            : user.licenseExpiryDate || 0,
                        ).setHours(23, 59, 59, 999) >= new Date()
                          ? "Active"
                          : "Expired"}
                      </span>
                    </td>
                    <td>
                      <span
                        title="Generate License"
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center cursor-pointer"
                        onClick={() => handleGenerateLicense(user._id)}
                      >
                        <Icon icon="lucide:key-round" />
                      </span>
                      <Link
                        to="#"
                        title="Preview"
                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          e.preventDefault(); // prevent default anchor behavior
                          handlePreview(user._id, user.cid);
                        }}
                      >
                        <Icon icon="iconamoon:eye-light" />
                      </Link>

                      <span
                        title="Delete"
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center cursor-pointer"
                        onClick={() => handleDelete(user._id)}
                      >
                        <Icon icon="mingcute:delete-2-line" />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {forms.length > 0 && (
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing {indexOfFirstRecord + 1} to{" "}
              {Math.min(indexOfLastRecord, forms.length)} of {forms.length}{" "}
              entries
            </span>
            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <Icon icon="ep:d-arrow-left" />
                </button>
              </li>
              {[...Array(totalPages).keys()].map((num) => (
                <li className="page-item" key={num + 1}>
                  <button
                    className={`page-link ${
                      currentPage === num + 1
                        ? "bg-primary-600 text-white"
                        : "bg-neutral-200 text-secondary-light"
                    } fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md`}
                    onClick={() => handlePageChange(num + 1)}
                  >
                    {num + 1}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <Icon icon="ep:d-arrow-right" />
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>

      {/* Confirmation Modal */}
      {showModal && (
        <div
          className="modal-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-container"
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              padding: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h5 className="modal-title">Confirm Action</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this admin?</p>
            </div>
            <div className="modal-footer d-flex justify-content-center gap-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirm}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            setIsOpen(false);
          }}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <PopupForm
            onclose={() => {
              setIsOpen(false);
              fetchData();
            }}
          />
        </DialogContent>
      </Dialog>

      {/* User Details Modal */}
      {/* <Modal
        isOpen={userModalShow}
        toggle={() => setUserModalShow(false)}
        centered
        size="lg"
      >
        <ModalHeader
          className="bg-neutral-600  p-10"
          toggle={() => setUserModalShow(false)}
        >
          <span className="text-white text-xl">Registered Company Details</span>
        </ModalHeader>
        <ModalBody
          style={{
            borderRadius: "10px",
          }}
        >
          {selectedUser ? (
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1 align-self-center">
                        <div className="text-muted">
                          <Row>
                            <Col lg={6}>
                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Company Name</h6>
                                <p className="text-sm">{selectedUser.name}</p>
                              </div>

                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Company Email</h6>
                                <p
                                  className="text-sm"
                                  id="enrphotographeremail"
                                >
                                  {selectedUser.email}
                                </p>
                              </div>

                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Company Phone</h6>
                                <p
                                  className="text-sm"
                                  id="enrPhotographerMobNo"
                                >
                                  +91 {selectedUser.cmobile}
                                </p>
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Company ID</h6>
                                <p
                                  className="text-sm"
                                  id="enrPhotographerPlace"
                                >
                                  {selectedUser.cid}
                                </p>
                              </div>

                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">
                                  Subscription Start Date
                                </h6>
                                <p className="text-sm" id="enrPhotographerAddr">
                                  {selectedUser.plan === "trial" &&
                                  selectedUser.trialStartDate
                                    ? new Date(
                                        selectedUser.trialStartDate
                                      ).toLocaleDateString()
                                    : selectedUser.licenseStartDate
                                    ? new Date(
                                        selectedUser.licenseStartDate
                                      ).toLocaleDateString()
                                    : "-"}
                                </p>
                              </div>

                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">
                                  Subscription End Date
                                </h6>
                                <p
                                  className="text-sm"
                                  id="enrPhotographerLinks"
                                >
                                  {selectedUser.plan === "trial" &&
                                  selectedUser.trialEndDate
                                    ? new Date(
                                        selectedUser.trialEndDate
                                      ).toLocaleDateString()
                                    : selectedUser.licenseExpiryDate
                                    ? new Date(
                                        selectedUser.licenseExpiryDate
                                      ).toLocaleDateString()
                                    : "-"}
                                </p>
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">
                                  Subscription Type
                                </h6>
                                <p className="text-sm" id="enrPhotographerPswd">
                                  <span
                                    className={`${
                                      selectedUser?.isActive
                                        ? selectedUser?.licenseExpiryDate
                                          ? "text-success-main" // Subscribed
                                          : "text-warning-main" // Trial
                                        : "text-danger-main" // Expired
                                    } py-4 rounded-pill fw-medium text-sm`}
                                    id="enrPhotographerPswd"
                                  >
                                    {selectedUser?.isActive
                                      ? selectedUser?.licenseExpiryDate
                                        ? "Subscribed"
                                        : "Trial"
                                      : "Expired"}
                                  </span>
                                </p>
                              </div>
                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Status</h6>
                                <p className="text-sm" id="enrPhotographerPswd">
                                  <span
                                    className={`${
                                      new Date(
                                        selectedUser.plan === "trial"
                                          ? selectedUser.trialEndDate || 0
                                          : selectedUser.licenseExpiryDate || 0
                                      ).setHours(23, 59, 59, 999) >= new Date()
                                        ? "text-success-main"
                                        : "text-danger-main"
                                    } px-4 py-4 rounded-pill fw-medium text-sm`}
                                  >
                                    {new Date(
                                      selectedUser.plan === "trial"
                                        ? selectedUser.trialEndDate || 0
                                        : selectedUser.licenseExpiryDate || 0
                                    ).setHours(23, 59, 59, 999) >= new Date()
                                      ? "Active"
                                      : "Expired"}
                                  </span>
                                </p>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="flex-1 font-semibold">
                                <h6 className="mb-1 text-lg">Scan Count</h6>
                                <p className="text-sm" id="enrPhotographerPswd">
                                  Scans Left: {50}/
                                  {50 - (selectedUser?.scanCount || 0)}
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <p className="text-center text-muted">No details available</p>
          )}
        </ModalBody>
      </Modal> */}

      {/* Generate License Modal */}
      <Dialog
        open={licenseModal}
        onClose={() => setLicenseModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" align="center" gutterTop fontWeight="bold">
            Generate License
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setLicenseModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            {/* Plan Category */}
            <TextField
              select
              fullWidth
              margin="normal"
              label="Select Plan Category"
              value={planCategory}
              onChange={(e) => {
                setPlanCategory(e.target.value);
                setDays("");
                setIsCustom(false);
                setScanLimit("");
                setIsCustomScanLimit(false);
              }}
              required
            >
              <MenuItem value="basic">Basic</MenuItem>
              <MenuItem value="pro">Pro</MenuItem>
              <MenuItem value="enterprise">Enterprise</MenuItem>
            </TextField>

            {/* Validity Selection */}
            {planCategory && (
              <TextField
                select
                fullWidth
                margin="normal"
                label="Select Validity"
                value={isCustom ? "custom" : days}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "custom") {
                    setIsCustom(true);
                    setDays("");
                  } else {
                    setIsCustom(false);
                    setDays(val);
                  }
                }}
                required
              >
                <MenuItem value="365">1 Year</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </TextField>
            )}

            {isCustom && (
              <TextField
                fullWidth
                margin="normal"
                label="Enter Custom Validity Days"
                type="number"
                value={days}
                onChange={(e) => setDays(e.target.value)}
                required
              />
            )}

            {/* Scan Limit for Basic Plan */}
            {planCategory === "basic" && (
              <>
                <TextField
                  select
                  fullWidth
                  margin="normal"
                  label="Select Monthly Scan Limit"
                  value={isCustomScanLimit ? "custom" : scanLimit}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "custom") {
                      setIsCustomScanLimit(true);
                      setScanLimit("");
                    } else {
                      setIsCustomScanLimit(false);
                      setScanLimit(val);
                    }
                  }}
                  required
                >
                  <MenuItem value="200">200</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </TextField>

                {isCustomScanLimit && (
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Enter Custom Monthly Scan Limit"
                    type="number"
                    value={scanLimit}
                    onChange={(e) => setScanLimit(e.target.value)}
                    required
                  />
                )}
              </>
            )}
          </DialogContent>

          <DialogActions
            style={{
              justifyContent: "center",
              margin: "10px",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => setLicenseModal(false)}
              color="error"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default CompaniesListLayer;
